import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../common/context/ApplicationPropertiesProvider";
export const HeaderSearchContext = createContext();
export const ACTIONS = {
    SET_CTA_CTO:"SET_CTA_CTO",
    SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT"

};
const initialState = {
    ctaCto: "",
    detailClient: null

};
const HeaderSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_CTA_CTO: {
      return {
        ...state,
        ctaCto: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
          ...state,
          detailClient: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
const HeaderSearchContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(HeaderSearchReducer, initialState);

  useEffect(() => {
    if (state.ctaCto) {
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) =>{
          dispatch({
              payload: response,
              type: ACTIONS.SET_DETAIL_CLIENT,
          });
   
        })
      }
  }, [state.ctaCto]);

  return (
    <HeaderSearchContext.Provider value={[state, dispatch]}>
      {children}
    </HeaderSearchContext.Provider>
  );
};
export default HeaderSearchContextProvider;
